aracwebshop.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: Aracwebshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference && this.preference !== "Grid View") {
			this.products_section.addClass("hidden");
		} else {
			this.products_section.removeClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;
			const item_code = this.escape_attr(item.item_code || "");
			const route = this.safe_internal_url(item.route);

			html += `<div class="item-card bg-white border border-slate-100 rounded-[1.25rem] md:rounded-[2rem] overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.02)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] hover:-translate-y-1.5 transition-all duration-500 flex flex-col h-full !p-2 md:!p-4 relative group" data-item-code="${item_code}" data-route="${route}">`;
			html += me.get_image_html(item, title);
			html += me.get_card_body_html(item, title, me.settings);
			html += `</div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);
	}

	get_image_html(item, title) {
		const raw_image = window.aracwebshopImages
			? window.aracwebshopImages.get_listing_image(item)
			: (item.thumbnail || item.website_image);
		const image = this.safe_image_url(raw_image);
		const route = this.safe_internal_url(item.route);
		const safe_title_attr = this.escape_attr(title);
		const item_code = this.escape_attr(item.item_code || "");
		const wishlist_enabled = !item.has_variants && this.settings.enable_wishlist;
		const wishlist_html = wishlist_enabled ? this.get_wishlist_icon(item) : '';
		
		// Generate smart badges (Dual-Pill Connected Tag support)
		let badges_html = "";
		const is_rtl = document.documentElement.dir === "rtl" || document.body.dir === "rtl" || window.getComputedStyle(document.documentElement).direction === "rtl" || (document.documentElement.lang || "en").toLowerCase().startsWith("ar");
		const container_radius = is_rtl ? "border-radius: 0 1rem 9999px 0;" : "border-radius: 1rem 0 0 9999px;";
		const badge_pad = "font-black text-[8px] md:text-[10px] uppercase tracking-wider ps-3.5 pe-2.5 py-0.5 md:ps-4 md:pe-3 md:py-1 shadow-2xs";

		let primary_title = "";
		let primary_bg = "#009688";
		let primary_fg = "#ffffff";
		let primary_route = "";

		if (item.is_best_seller) {
			primary_title = __("Bestseller");
			primary_bg = "#009688";
		} else if (item.campaign_badge) {
			primary_title = item.campaign_badge.title;
			primary_bg = this.safe_color(item.campaign_badge.badge_bg_color, "#4f46e5");
			primary_fg = this.safe_color(item.campaign_badge.badge_text_color, "#ffffff");
			primary_route = item.campaign_badge.route || ('campaign/' + item.campaign_badge.slug);
		} else if (Boolean(item.is_new || item.custom_is_new)) {
			primary_title = __("New");
			primary_bg = "#2563eb";
		}

		let secondary_title = "";
		if (item.discount_percentage && item.discount_percentage > 0) {
			secondary_title = `${Math.round(item.discount_percentage)}% ${__("OFF")}`;
		} else if (item.formatted_mrp && item.formatted_price) {
			secondary_title = __("Sale");
		}

		const single_radius_style = is_rtl ? "border-radius: 9999px 1.25rem 0.25rem 9999px;" : "border-radius: 1.25rem 9999px 9999px 0.25rem;";
		const primary_radius_style = is_rtl ? "border-radius: 0 1.25rem 0.25rem 0;" : "border-radius: 1.25rem 0 0 0.25rem;";
		const secondary_radius_style = is_rtl ? "border-radius: 9999px 0 0 0.5rem; border-right: 0;" : "border-radius: 0 9999px 9999px 0; border-left: 0;";

		if (primary_title && secondary_title) {
			// Connected Dual-Pill Badge Tag
			const link_attr = primary_route ? `href="${this.safe_internal_url(primary_route)}"` : "";
			const tag_el = primary_route ? "a" : "div";
			badges_html += `
				<${tag_el} ${link_attr} class="inline-flex items-stretch overflow-hidden shadow-sm pointer-events-auto hover:scale-[1.02] transition-transform duration-200">
					<span style="background-color: ${primary_bg} !important; color: ${primary_fg} !important; ${primary_radius_style}" class="font-black text-[8px] md:text-[10px] uppercase tracking-wider ps-3.5 pe-2 py-0.5 md:ps-4 md:pe-2.5 md:py-1 flex items-center shrink-0">
						${this.escape_html(primary_title)}
					</span>
					<span style="border-color: ${primary_bg}; color: ${primary_bg}; ${secondary_radius_style}" class="bg-white border-2 font-black text-[8px] md:text-[10px] uppercase tracking-wider px-2 py-0.5 md:px-2.5 md:py-1 flex items-center shrink-0">
						${this.escape_html(secondary_title)}
					</span>
				</${tag_el}>
			`;
		} else if (primary_title) {
			const link_attr = primary_route ? `href="${this.safe_internal_url(primary_route)}"` : "";
			const tag_el = primary_route ? "a" : "div";
			badges_html += `
				<${tag_el} ${link_attr} style="background-color: ${primary_bg} !important; color: ${primary_fg} !important; ${single_radius_style}" class="${badge_pad} flex items-center gap-1 pointer-events-auto hover:scale-[1.02] transition-transform">
					<span>${this.escape_html(primary_title)}</span>
				</${tag_el}>
			`;
		} else if (secondary_title) {
			badges_html += `<div style="background-color: #f43f5e; color: #ffffff; ${single_radius_style}" class="${badge_pad} flex items-center">${this.escape_html(secondary_title)}</div>`;
		}

		if (item.custom_promo_badge && !primary_title) {
			badges_html += `
				<button type="button" style="${single_radius_style}" class="promo-badge-trigger bg-slate-900 text-amber-300 ${badge_pad} flex items-center gap-1 cursor-pointer pointer-events-auto hover:brightness-110 hover:scale-[1.02] active:scale-95 transition-all duration-200 border border-amber-400/50 whitespace-nowrap"
					data-promo-title="${this.escape_attr(item.custom_promo_badge)}" data-promo-detail="${this.escape_attr(item.custom_promo_detail || '')}">
					<svg class="w-2.5 h-2.5 text-amber-400 shrink-0" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M5 5a3 3 0 015-3c1.756 0 3 1.244 3 3 0 .552-.15 1.07-.41 1.513A4.985 4.985 0 0115 10v5a2 2 0 01-2 2H7a2 2 0 01-2-2v-5c0-1.306.5-2.498 1.32-3.393A2.96 2.96 0 015 5zm3-1a1 1 0 100 2h.01a1 1 0 100-2H8z" clip-rule="evenodd" />
					</svg>
					${this.escape_html(item.custom_promo_badge)}
				</button>
			`;
		}

		const position_style = is_rtl ? "right: 0 !important; left: auto !important; align-items: flex-end !important;" : "left: 0 !important; right: auto !important; align-items: flex-start !important;";
		const badge_container = badges_html ? `
			<div class="absolute top-0 flex flex-col gap-1 z-10 pointer-events-none" style="${position_style} margin: 0 !important; padding: 0 !important;">
				${badges_html}
			</div>
		` : "";

		let cart_overlay_html = "";
		const variant_cart_qty = parseFloat(item.variant_in_cart_qty || 0) || 0;
		if (item.has_variants && this.settings.enabled) {
			const template_code = this.escape_attr(item.item_code || "");
			const hidden_class = variant_cart_qty > 0 ? "" : "hidden";
			const in_cart_color = this.safe_color(this.settings.custom_theme_in_cart_color, "#059669");
			cart_overlay_html = `
				<button type="button" class="arac-template-cart-badge btn-explore-variants absolute bottom-2 right-2 rtl:right-auto rtl:left-2 md:bottom-3 md:right-3 md:rtl:right-auto md:rtl:left-3 w-8 h-8 md:w-9 md:h-9 text-white rounded-full flex items-center justify-center shadow-lg z-10 cursor-pointer hover:scale-105 transition-transform select-none ${hidden_class}"
					style="background-color: ${in_cart_color} !important; color: #ffffff !important; border: 2px solid #ffffff !important; box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15) !important;"
					data-template-item-code="${template_code}" data-template-cart-qty="${variant_cart_qty}" data-item-code="${template_code}" data-route="${route}" aria-label="${this.escape_attr(__("View variants in cart"))}">
					<span class="arac-template-cart-qty cart-qty-display font-extrabold text-xs md:text-sm leading-none text-center flex items-center justify-center w-full h-full select-none" style="color: #ffffff !important;">${parseInt(variant_cart_qty, 10)}</span>
				</button>
			`;
		}
		if (!item.has_variants && this.settings.enabled && (this.settings.allow_items_not_in_stock || item.in_stock)) {
			const qty = parseInt(item.in_cart_qty || (item.in_cart ? 1 : 0), 10);
			const in_cart = qty > 0;
			const themeColor = this.safe_color(this.settings && this.settings.custom_theme_primary_color, '#449CF0');
			const inCartColor = this.safe_color(this.settings && this.settings.custom_theme_in_cart_color, '#059669');
			const stock_qty = this.safe_number(item.stock_qty || item.actual_qty);
			const max_qty = this.safe_number(item.custom_max_qty_per_order || item.max_quantity);
			cart_overlay_html = `
				<div class="cart-btn-overlay-container absolute bottom-2 right-2 rtl:right-auto rtl:left-2 md:bottom-3 md:right-3 md:rtl:right-auto md:rtl:left-3 flex items-center justify-end z-10" data-item-code="${item_code}" data-stock-qty="${stock_qty}" data-max-qty="${max_qty}" data-allow-out-of-stock="${this.settings && this.settings.allow_items_not_in_stock ? 'true' : 'false'}">
					<!-- 1. Circular Plus Button (Initial State: Not in Cart) -->
					<button class="w-8 h-8 md:w-9 md:h-9 text-white rounded-full flex items-center justify-center shadow-lg active:scale-95 transition-all duration-300 btn-add-to-cart-circle ${in_cart ? 'hidden' : ''}" style="background-color: ${themeColor} !important; color: #ffffff !important;" data-item-code="${item_code}">
						<svg class="w-4 h-4 md:w-4.5 md:h-4.5 stroke-[2.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<line x1="12" y1="5" x2="12" y2="19"></line>
							<line x1="5" y1="12" x2="19" y2="12"></line>
						</svg>
					</button>

					<!-- 2. Loading Spinner -->
					<div class="w-8 h-8 md:w-9 md:h-9 text-white rounded-full flex items-center justify-center shadow-lg btn-cart-loading hidden" style="background-color: ${themeColor} !important; color: #ffffff !important;">
						<svg class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
							<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
							<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
						</svg>
					</div>

					<!-- 3. Collapsed Count Circle Badge (In Cart - Collapsed State with distinct active emerald green) -->
					<div class="w-8 h-8 md:w-9 md:h-9 text-white rounded-full flex items-center justify-center shadow-lg btn-cart-collapsed ${in_cart ? '' : 'hidden'} cursor-pointer hover:scale-105 transition-transform select-none" style="background-color: ${inCartColor} !important; color: #ffffff !important;" data-qty="${qty}">
						<span class="cart-qty-display font-extrabold text-xs md:text-sm leading-none text-center flex items-center justify-center w-full h-full select-none" style="color: #ffffff !important;">${qty}</span>
					</div>

					<!-- 4. Expanded Quantity Controller Pill (In Cart - Active Clicked State) -->
					<div class="h-8 md:h-9 text-white rounded-full flex items-center justify-between px-2.5 shadow-lg transition-all duration-300 btn-cart-pill-expanded w-full hidden" style="background-color: ${inCartColor} !important; color: #ffffff !important; border-radius: 9999px !important; width: 100% !important;">
						<button class="w-8 md:w-9 h-full flex items-center justify-center hover:bg-white/20 active:scale-90 transition-all text-base font-black btn-decrease-qty" style="color: #ffffff !important;" data-item-code="${item_code}">−</button>
						<span class="text-xs md:text-sm font-extrabold text-white text-center select-none px-2 cart-qty-display flex items-center justify-center leading-none" style="color: #ffffff !important;">${qty}</span>
						<input type="hidden" class="input-cart-qty" value="${qty}" />
						<button class="w-8 md:w-9 h-full flex items-center justify-center hover:bg-white/20 active:scale-90 transition-all text-base font-black btn-increase-qty" style="color: #ffffff !important;" data-item-code="${item_code}">+</button>
					</div>
				</div>
			`;
		}

		const is_out_of_stock = !item.has_variants && this.settings && !this.settings.allow_items_not_in_stock && !item.in_stock;
		let out_of_stock_overlay = "";
		if (is_out_of_stock) {
			const oos_label = __("Out of Stock") !== "Out of Stock" ? __("Out of Stock") : (__("Out of stock") !== "Out of stock" ? __("Out of stock") : (document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl' ? "إنتهى من المخزن" : "Out of Stock"));
			out_of_stock_overlay = `
				<div class="absolute inset-0 z-20 flex items-center justify-center p-3 pointer-events-none rounded-[1rem] md:rounded-[1.5rem]" style="background-color: rgba(15, 23, 42, 0.35) !important; -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px);">
					<div class="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1 md:px-4.5 md:py-2 rounded-full bg-slate-900/95 text-white shadow-xl border border-white/20 backdrop-blur-md transform transition-transform duration-300 group-hover:scale-105 select-none" style="background-color: rgba(20, 27, 44, 0.95) !important; color: #ffffff !important; border-radius: 9999px !important; border: 1px solid rgba(255, 255, 255, 0.25) !important; display: inline-flex !important; align-items: center !important;">
						<svg class="w-3.5 h-3.5 md:w-4 md:h-4 text-rose-400 shrink-0" style="color: #fb7185; flex-shrink: 0;" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
							<circle cx="12" cy="12" r="10"></circle>
							<line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
						</svg>
						<span class="text-[9px] md:text-xs font-black uppercase tracking-wider text-white whitespace-nowrap" style="color: #ffffff !important; font-weight: 800 !important; text-transform: uppercase !important; letter-spacing: 0.05em !important; white-space: nowrap !important;">${this.escape_html(oos_label)}</span>
					</div>
				</div>
			`;
		}

		if (image) {
			return `
				<div class="relative w-full aspect-square overflow-hidden rounded-[1rem] md:rounded-[1.5rem] bg-slate-50 mb-2 md:mb-3 flex items-center justify-center">
					<a href="${route}" class="w-full h-full flex items-center justify-center">
						<img itemprop="image" class="arac-product-card-image object-cover w-full h-full group-hover:scale-105 transition-transform duration-700 ${ is_out_of_stock ? 'grayscale-[30%] opacity-80' : '' }" src="${image}" data-arac-image-src="${image}" alt="${safe_title_attr}" loading="lazy" decoding="async">
					</a>
					${ wishlist_html }
					${ badge_container }
					${ cart_overlay_html }
					${ out_of_stock_overlay }
				</div>
			`;
		} else {
			const abbreviation = this.escape_html(frappe.get_abbr(title));
			return `
				<div class="relative w-full aspect-square overflow-hidden rounded-[1rem] md:rounded-[1.5rem] bg-gradient-to-br from-slate-50 to-slate-100/80 mb-2 md:mb-3 flex items-center justify-center group-hover:bg-gradient-to-br group-hover:from-theme-primary-light group-hover:to-theme-primary-light transition-colors duration-500">
					<a href="${route}" class="w-full h-full flex items-center justify-center">
						<div class="w-10 h-10 md:w-16 md:h-16 rounded-xl md:rounded-2xl bg-white shadow-sm flex items-center justify-center text-theme-primary font-extrabold text-sm md:text-lg tracking-wider transform group-hover:scale-110 transition-transform duration-500 border border-slate-100">
							${abbreviation}
						</div>
					</a>
					${ wishlist_html }
					${ badge_container }
					${ cart_overlay_html }
					${ out_of_stock_overlay }
				</div>
			`;
		}
	}

	get_card_body_html(item, title, settings) {
		let body_html = `
			<div class="flex flex-col flex-grow w-full">
				<div class="flex justify-between items-start mb-1">
		`;
		body_html += this.get_title(item, title);
		body_html += `</div>`;
		
		body_html += `<span class="text-[9px] md:text-[10px] font-bold text-theme-primary uppercase tracking-widest mb-0.5 block">${this.escape_html(item.item_group || '')}</span>`;

		// Dynamic Star rating layout
		if (settings.enable_reviews) {
			const avg_rating = flt(item.average_rating) || 0.0;
			const filled_stars = Math.round(avg_rating);
			let stars_html = "";
			for (let i = 1; i <= 5; i++) {
				if (i <= filled_stars) {
					stars_html += `<svg class="w-3.5 h-3.5 fill-current text-amber-400" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
				} else {
					stars_html += `<svg class="w-3.5 h-3.5 fill-current text-slate-200" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
				}
			}
			body_html += `
				<div class="flex items-center gap-0.5 md:gap-1 mb-0.5 md:mb-1">
					<div class="flex">
						${stars_html}
					</div>
					<span class="text-[9px] md:text-[10px] font-semibold text-slate-400">(${avg_rating.toFixed(1)})</span>
				</div>
			`;
		}

		body_html += `<div class="mt-auto flex flex-col w-full">`;

		const use_dropdown = settings && settings.show_uom_in_dropdown;
		const show_inline_uom = Boolean(item.formatted_price && !use_dropdown && item.uoms && item.uoms.length === 1);
		const inline_uom_html = show_inline_uom ? this.get_inline_uom_html(item) : "";

		if (item.formatted_price) {
			body_html += this.get_price_html(item, inline_uom_html);
		} else {
			const price_label = item.has_variants ? __("Price varies by option") : __("Price on request");
			body_html += `
				<div class="flex items-baseline gap-2 mb-0.5 md:mb-1">
					<span class="text-xs font-semibold text-slate-400 italic">${this.escape_html(price_label)}</span>
				</div>
			`;
		}

		body_html += this.get_stock_availability(item, settings);

		const uom_html = this.get_uom_selection(item, settings, show_inline_uom);
		const button_html = this.get_primary_button(item, settings);

		if (use_dropdown && uom_html) {
			// Dropdown mode: UOM dropdown (60%) + button (40%)
			body_html += `
				<div class="w-full mt-1.5 flex items-center gap-1.5 md:gap-2">
					<div class="flex-[3] min-w-0">${ uom_html }</div>
					<div class="flex-[2]">${ button_html }</div>
				</div>
			`;
		} else {
			// Default mode: UOM chips row, then button row
			if (uom_html) {
				body_html += uom_html;
			}
			body_html += `
				<div class="w-full mt-1">
					${ button_html }
				</div>
			`;
		}
		body_html += `</div>`;
		body_html += `</div>`;

		return body_html;
	}

	get_title(item, title) {
		return `
			<a href="${this.safe_internal_url(item.route)}" class="hover:text-theme-primary transition-colors w-full">
				<h3 class="text-xs md:text-sm font-bold text-slate-800 line-clamp-2 leading-snug">${this.escape_html(title)}</h3>
			</a>
		`;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "fill-red-500 stroke-red-500 wished" : "stroke-slate-400 fill-none group-hover/wish:stroke-red-500 not-wished";
		return `
			<button class="absolute top-2 right-2 rtl:right-auto rtl:left-2 md:top-3 md:right-3 md:rtl:right-auto md:rtl:left-3 p-1.5 md:p-2 bg-white/80 hover:bg-white backdrop-blur-sm rounded-full shadow-sm hover:scale-105 active:scale-95 transition-all duration-200 z-10 group/wish like-action ${ item.wished ? 'like-action-wished' : ''}" data-item-code="${this.escape_attr(item.item_code)}">
				<svg class="w-3.5 h-3.5 md:w-4 md:h-4 ${ icon_class } wish-icon transition-colors duration-200" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none">
					<path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
				</svg>
			</button>
		`;
	}

	get_cart_indicator(item) {
		return `
			<div class="absolute top-3 left-3 bg-emerald-500 text-white text-[10px] font-bold px-2 py-1 rounded-lg shadow-sm flex items-center gap-1 z-10 cart-indicator ${item.in_cart ? '' : 'hidden'}" data-item-code="${this.escape_attr(item.item_code)}">
				<svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
					<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
				</svg>
				${this.escape_html(__("Added"))}
			</div>
		`;
	}

	get_price_html(item, inline_uom_html = "") {
		const price_info = window.aracwebshopPrice.get_initial_price(item || {});
		const initial_price = window.aracwebshopPrice.escape_attr(price_info.display);
		const base_formatted = window.aracwebshopPrice.escape_attr(price_info.base_formatted);

		let price_html = `
			<div class="arac-card-price-row flex items-center gap-1.5 mb-0.5 md:mb-1 flex-wrap">
				<span class="text-sm md:text-lg font-black text-slate-900 product-card-price" data-base-formatted="${ base_formatted }">${ initial_price || '' }</span>
				${ inline_uom_html }
		`;

		if (item.formatted_mrp) {
			const formatted_mrp = this.escape_html(item.formatted_mrp.replace(/ +/g, ""));
			const discount = this.escape_html(item.discount || "");
			price_html += `
				<span class="text-[10px] md:text-xs text-slate-400 line-through striked-price">
					${formatted_mrp}
				</span>
				<span class="text-[9px] md:text-[10px] font-bold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded-md product-info-green">
					${discount} ${this.escape_html(__("OFF"))}
				</span>
			`;
		}
		price_html += `</div>`;
		return price_html;
	}

	get_uom_label(uom) {
		if (!uom) return "";
		return window.aracwebshopPrice.escape_attr(
			uom.uom_label || window.aracwebshopPrice.get_uom_label(uom.uom || "", uom.conversion_factor)
		);
	}

	get_inline_uom_html(item) {
		const uom = item.uoms && item.uoms.length ? item.uoms[0] : null;
		if (!uom || !uom.uom) return "";

		const item_code = this.escape_attr(item.item_code || "");
		const uom_value = this.escape_attr(uom.uom || "");
		const uom_label = this.get_uom_label(uom);
		const conversion_factor = this.safe_number(uom.conversion_factor, "1");

		return `
			<input type="hidden" class="selected-uom"
				   value="${uom_value}"
				   data-conversion="${conversion_factor}"
				   data-item-code="${item_code}">
			<span class="arac-card-uom-badge text-[9px] md:text-[10px] text-slate-500 font-bold px-1.5 py-0.5 bg-slate-100 rounded-md inline-flex items-center shrink-0 truncate" style="max-width: 58%;" title="${uom_label}">${uom_label}</span>
		`;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<span class="text-[10px] md:text-xs font-semibold text-theme-primary bg-theme-primary-light px-2 py-1 rounded-lg inline-block mb-0.5 md:mb-1">
						${this.escape_html(__("Available on backorder"))}
					</span>
				`;
			}
		}
		return ``;
	}

	get_uom_selection(item, settings, skip_single_inline = false) {
		if (!item.uoms || item.uoms.length === 0) return '';
		const use_dropdown = settings && settings.show_uom_in_dropdown;
		const item_code = this.escape_attr(item.item_code || "");

		let uom_html = use_dropdown 
			? '<div>' 
			: '<div class="uom-selection-wrapper mt-0.5 md:mt-1">';

		if (item.uoms.length > 1) {
			// Always render the hidden data-select for cart compatibility
			uom_html += `
				<select class="hidden uom-select" data-item-code="${item_code}">
			`;
			item.uoms.forEach(uom => {
				const formatted_price = this.escape_attr(uom.formatted_price || "");
				const uom_value = this.escape_attr(uom.uom || "");
				const uom_label = this.get_uom_label(uom);
				const conversion_factor = this.safe_number(uom.conversion_factor, "1");
				const price = this.safe_number(uom.price_list_rate, "0");
				uom_html += `
					<option value="${uom_value}"
							data-conversion="${conversion_factor}"
							data-price="${price}"
							data-formatted-price="${formatted_price}">
						${uom_label}
					</option>
				`;
			});
			uom_html += `</select>`;

			if (use_dropdown) {
				// ─── Styled dropdown ───
				uom_html += `
					<div class="uom-dropdown-wrapper relative w-full">
						<select class="uom-dropdown-select arac-grid-uom-select w-full outline-none transition-all duration-200 cursor-pointer shadow-sm hover:shadow" data-item-code="${item_code}">
				`;
				item.uoms.forEach(uom => {
					const formatted_price = this.escape_attr(uom.formatted_price || "");
					const uom_value = this.escape_attr(uom.uom || "");
					const uom_label = this.get_uom_label(uom);
					const conversion_factor = this.safe_number(uom.conversion_factor, "1");
					const price = this.safe_number(uom.price_list_rate, "0");
					uom_html += `<option value="${uom_value}" data-conversion="${conversion_factor}" data-price="${price}" data-formatted-price="${formatted_price}">${uom_label}</option>`;
				});
				uom_html += `
						</select>
						<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
							<svg class="w-2.5 h-2.5 md:w-3 md:h-3 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
								<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
							</svg>
						</div>
					</div>
				`;
			} else {
				// ─── Default: UOM chip buttons ───
				uom_html += `<div class="flex flex-wrap gap-1 uom-chips-container" data-item-code="${item_code}">`;
				item.uoms.forEach((uom, index) => {
					const uom_value = this.escape_attr(uom.uom || "");
					const uom_label = this.get_uom_label(uom);
					const conversion_factor = this.safe_number(uom.conversion_factor, "1");
					const price = this.safe_number(uom.price_list_rate, "0");
					let activeClass = index === 0 
						? "bg-theme-primary text-white shadow-sm shadow-theme-primary/10 font-bold border-theme-primary" 
						: "bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-800 border-slate-200";
					uom_html += `
						<button type="button" class="uom-chip px-2 py-0.5 md:px-3 md:py-1 border rounded-md md:rounded-lg text-[10px] md:text-xs font-semibold transition-all duration-200 cursor-pointer ${activeClass}" 
								data-uom="${uom_value}"
								data-conversion="${conversion_factor}"
								data-price="${price}"
								data-formatted-price="${this.escape_attr(uom.formatted_price || "")}">
							${uom_label}
						</button>
					`;
				});
				uom_html += `</div>`;
			}
		} else {
			const uom = item.uoms[0];
			const uom_value = this.escape_attr(uom.uom || "");
			const uom_label = this.get_uom_label(uom);
			const conversion_factor = this.safe_number(uom.conversion_factor, "1");
			if (skip_single_inline && !use_dropdown) {
				return '';
			}
			if (use_dropdown) {
				// Single UOM label — same height as dropdown
				uom_html += `
					<input type="hidden" class="selected-uom" 
						   value="${uom_value}"
						   data-conversion="${conversion_factor}"
						   data-item-code="${item_code}">
					<div class="w-full arac-grid-uom-label bg-white border border-slate-200 shadow-sm">
						<span class="text-slate-600">${uom_label}</span>
					</div>
				`;
			} else {
				uom_html += `
					<input type="hidden" class="selected-uom" 
						   value="${uom_value}"
						   data-conversion="${conversion_factor}"
						   data-item-code="${item_code}">
					<div class="text-[9px] md:text-[10px] text-slate-500 font-bold px-1.5 py-0.5 bg-slate-100 rounded-md inline-block">${uom_label}</div>
				`;
			}
		}

		uom_html += '</div>';
		return uom_html;
	}

	get_primary_button(item, settings) {
		const use_dropdown = settings.show_uom_in_dropdown;
		const item_code = this.escape_attr(item.item_code || "");
		const route = this.safe_internal_url(item.route);

		if (item.has_variants) {
			if (use_dropdown) {
				return `
					<button class="w-full arac-grid-uom-btn bg-slate-800 hover:bg-slate-900 text-white shadow-sm hover:shadow-md active:scale-[0.97] transition-all btn-explore-variants gap-1 whitespace-nowrap" data-item-code="${item_code}" data-route="${route}">
						<svg class="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<rect x="3" y="3" width="7" height="7"></rect>
							<rect x="14" y="3" width="7" height="7"></rect>
							<rect x="14" y="14" width="7" height="7"></rect>
							<rect x="3" y="14" width="7" height="7"></rect>
						</svg>
						<span class="hidden md:inline">${this.escape_html(__("Options"))}</span>
					</button>
				`;
			}
			return `
				<button class="w-full py-1.5 md:py-2 px-3 md:px-4 bg-slate-800 hover:bg-slate-900 text-white rounded-lg md:rounded-xl font-bold text-[10px] md:text-xs shadow-sm hover:shadow-md hover:shadow-slate-800/10 active:scale-[0.98] transition-all flex items-center justify-center gap-1 btn-explore-variants whitespace-nowrap" data-item-code="${item_code}" data-route="${route}">
					<span>${this.escape_html(__("View Options"))}</span>
					<svg class="w-3 h-3 md:w-3.5 md:h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<line x1="5" y1="12" x2="19" y2="12"></line>
						<polyline points="12 5 19 12 12 19"></polyline>
					</svg>
				</button>
			`;
		} else {
			// Out of stock overlay badge is rendered over product image
			return ``;
		}
	}

	escape_attr(value) {
		return window.aracwebshopPrice.escape_attr(value);
	}

	escape_html(value) {
		return window.aracwebshopPrice.escape_html(value);
	}

	safe_color(value, fallback) {
		return window.aracwebshopPrice.safe_color(value, fallback);
	}

	safe_image_url(value) {
		return window.aracwebshopPrice.safe_image_url(value);
	}

	safe_internal_url(value) {
		return window.aracwebshopPrice.safe_internal_url(value);
	}

	safe_number(value, fallback = "") {
		const number = Number(value);
		return Number.isFinite(number) ? String(number) : fallback;
	}
};

frappe.ready(() => {
	// Handle UOM selection via buttons/chips in grid/list
	$(document).on('click', '.uom-chip', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const $chip = $(this);
		const $container = $chip.closest('.uom-chips-container');
		const uom_val = $chip.data('uom');
		
		// Update active class styles
		$container.find('.uom-chip')
			.removeClass("bg-theme-primary text-white shadow-sm shadow-theme-primary/10 font-bold border-theme-primary")
			.addClass("bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-800 border-slate-200");
		$chip
			.removeClass("bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-800 border-slate-200")
			.addClass("bg-theme-primary text-white shadow-sm shadow-theme-primary/10 font-bold border-theme-primary");
		
		// Update matching hidden select
		const $select = $container.siblings('.uom-select');
		if ($select.length) {
			const $opt = $select.find('option').filter(function() {
				return String($(this).val()) === String(uom_val);
			}).first();
			if ($opt.length) {
				$select.val(uom_val).trigger('change');
			}
		}
	});

	// Handle standard select change to update price and data
	$(document).on('change', '.uom-select', function() {
		const $select = $(this);
		const selectedOption = $select.find('option:selected');
		const $card = $select.closest('.item-card');
		
		$card.data('uom', selectedOption.val())
			 .data('conversion', selectedOption.data('conversion'));

		const price = parseFloat(selectedOption.data('price')) || 0;
		const formattedPrice = selectedOption.data('formatted-price') || selectedOption.attr('data-formatted-price') || "";
		window.aracwebshopPrice.update_price_element($card.find('.product-card-price'), price, formattedPrice);
	});

	// Handle visible UOM dropdown change (dropdown mode)
	$(document).on('change', '.uom-dropdown-select', function() {
		const $dropdown = $(this);
		const item_code = $dropdown.data('item-code');
		const selectedVal = $dropdown.val();
		const $card = $dropdown.closest('.item-card');

		// Sync with the hidden .uom-select
		const $hiddenSelect = $card.find('.uom-select').filter(function() {
			return String($(this).data('item-code')) === String(item_code);
		}).first();
		if ($hiddenSelect.length) {
			$hiddenSelect.val(selectedVal).trigger('change');
		}

		// Also update price directly from the visible dropdown's data
		const $opt = $dropdown.find('option:selected');
		const price = parseFloat($opt.data('price')) || 0;
		const formattedPrice = $opt.data('formatted-price') || $opt.attr('data-formatted-price') || "";
		window.aracwebshopPrice.update_price_element($card.find('.product-card-price'), price, formattedPrice);
	});

	function format_price_element($el) {
		if ($el.hasClass('formatted-en-style')) return;
		
		let baseFormatted = $el.data('base-formatted') || $el.text().trim();
		if (!baseFormatted || baseFormatted === __("Price Unavailable") || baseFormatted === __("Select options to view price")) return;

		const normalized = window.aracwebshopPrice.normalize(baseFormatted);
		if (normalized) {
			if (!$el.data('base-formatted')) {
				$el.attr('data-base-formatted', normalized);
			}
			$el.text(normalized);
			$el.addClass('formatted-en-style');
		}
	}

	function format_all_prices() {
		$('.product-card-price, .striked-price, .main-product-price, .main-product-mrp, .active-uom-display, .unit-price-display').each(function() {
			format_price_element($(this));
		});
	}

	// Format on initial load
	format_all_prices();
	setTimeout(format_all_prices, 100);

	// Format after any AJAX calls (e.g. pagination, filters)
	$(document).ajaxComplete(() => {
		setTimeout(format_all_prices, 50);
	});
});
